import React from 'react';
import { ImageWrapper } from './index.view';

export interface ProfileImageProps {
  source: string | undefined;
  width: string | number | undefined;
  height: string | number | undefined;
  position?: string;
  borderSize?: number;
  rounded?: boolean;
  objectFit?: 'cover' | 'contain';
}
const ProfileImage = ({
  source,
  width,
  height,
  position,
  borderSize,
  rounded = true,
  objectFit = 'cover',
}: ProfileImageProps) => {
  return (
    <ImageWrapper
      width={width}
      height={height}
      position={position}
      src={source}
      borderSize={borderSize}
      rounded={rounded}
      objectFit={objectFit}
    />
  );
};

export default ProfileImage;
